import { render, staticRenderFns } from "./beta-codes-info.vue?vue&type=template&id=61ba1730&"
import script from "./beta-codes-info.vue?vue&type=script&lang=js&"
export * from "./beta-codes-info.vue?vue&type=script&lang=js&"
import style0 from "./beta-codes-info.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/alpheios-core/alpheios-core/packages/components/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61ba1730')) {
      api.createRecord('61ba1730', component.options)
    } else {
      api.reload('61ba1730', component.options)
    }
    module.hot.accept("./beta-codes-info.vue?vue&type=template&id=61ba1730&", function () {
      api.rerender('61ba1730', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vue/components/beta-codes-info.vue"
export default component.exports